export default {"src":"/_next/static/media/ship-skis.e49ea70b.svg","height":524,"width":927,"blurWidth":0,"blurHeight":0};